<div class="row overflow-hidden h-100">

  <aside role="presentation"
         data-automation-id="search-root-aside"
         [ngClass]="isSidebarInFullscreen ? 'd-block' : 'd-none'"
         [class.order-first]="translateService.currentLang !== 'ar'"
         [class.limit-expanded-width]="isSidebarExpanded && !isSidebarInFullscreen"
         [class.limit-collapsed-width]="!isSidebarExpanded && !isSidebarInFullscreen"
         class="col-sm-5 col-md-4 col-xl-3 d-sm-block px-0 h-100">
    <app-filter-panel-container [isKidsCatalog]="isKidsCatalog">
    </app-filter-panel-container>
  </aside>
  <main tabindex="-1" #main
        data-automation-id="search-root-main"
        [ngClass]="isSidebarInFullscreen ? 'd-none' : 'd-block'"
        class="col-sm d-sm-block p-0">
    <router-outlet (activate)="main.focus()"></router-outlet>
  </main>
</div>
